// @flow
import { createPortal } from 'react-dom';
import { MapControl, withLeaflet } from 'react-leaflet';

import { Control, DomUtil } from 'leaflet';
import { any } from 'prop-types';
import { V4MAPPED } from 'dns';

// import type { MapControlProps } from './types'

const Watermark = Control.extend({
  __test: null,

  // onAdd: (map: any,a1: any, a2:any)  => {
  //   // @ts-ignore
  //   var divEl = DomUtil.create('div');

  //   // img.src = 'https://leafletjs.com/docs/images/logo.png';
  //   // img.style.width = '200px';
  //   // img.addEventListener('click', () => {
  //   //   alert('wow');
  //   // });

  //   // @ts-ignore
  //   // console.log({
  //     map,
  //     a1,
  //     a2,
  //   });

  //   // const divEl = document.createElement('DIV');
  //   divEl.innerHTML = 'aaa';
  //   // @ts-ignore
  //   // this.__test = divEl

  //   return divEl;
  // },

  onRemove: function(map: any) {
    // Nothing to do here
  },
});

// class ZoomControl extends MapControl<LeafletElement, Props> {
//   createLeafletElement(props: Props): LeafletElement {
//     return new Control.Zoom(props)
//   }
// }

class DivControl extends MapControl<any> {
  leafletElement: any;

  constructor(props: any) {
    super(props);
    this.leafletElement = this.createLeafletElement(props);
    // this.__contentNode = document.createElement('div');
    // // console.log('>>> step 1');
  }
  __contentNode: any;
  __test: any;

  // getContentNode() =

  createLeafletElement(props: any) {
    // return new Control.Zoom(props)

    // // console.log('>>> step 0');

    const self1 = this;

    const wm: any = new Watermark(props);

    this.__contentNode = document.createElement('div');

    const contentNode = this.__contentNode;
    // // console.log({ self1, contentNode });

    wm.onAdd = (map: any, a1: any, a2: any) => {
      // @ts-ignore
      var divEl = DomUtil.create('div');

      // img.src = 'https://leafletjs.com/docs/images/logo.png';
      // img.style.width = '200px';
      // img.addEventListener('click', () => {
      //   alert('wow');
      // });

      // @ts-ignore
      // // console.log({
      //   map,
      //   a1,
      //   a2,
      // });

      self1.__test = divEl;

      // const divEl = document.createElement('DIV');
      // divEl.innerHTML = 'aaa';
      // // console.log(contentNode);
      divEl.appendChild(contentNode);

      // @ts-ignore
      // this.__test = divEl

      return divEl;
    };

    // console.log('1');

    return wm;
  }

  render() {
    // // console.log('2');

    // // console.log({
    //   that: this,
    //   this: this.__test,
    // });
    if (this.__contentNode && this.props.children) {
      // console.log('>>> aaa');
      return createPortal(this.props.children, this.__contentNode);
    }
    // if (this.__test && this.props.children) {
    //   return createPortal(this.props.children, this.__test)
    // }
    return null;
  }
}

export default withLeaflet(DivControl);
